// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root___LpBm","disabled":"FileBtn_disabled__2W9NR","warn":"FileBtn_warn__3k89y","fade":"FileBtn_fade__1iPsS"};